import { css } from "@emotion/react";

export const menuOpenButton = css`
    position: relative;
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    padding: 6px;
    background-color: #fff;
    border: 1px solid lightgray;
    border-radius: 100%;
    cursor: pointer;

    &:hover {
        filter: blur(0.5px);
    }
`

export const menuOpenButtonImg = (isOpen) => css`
    width: 100%;
    filter: ${isOpen ? "invert(34%) sepia(73%) saturate(2534%) hue-rotate(209deg) brightness(101%) contrast(95%)" : "none"};
`

export const modeSelectorContainer = (isOpen) => css`
    display: ${isOpen ? "block" : "none"};
    position: absolute;
    right: 50px;
    top: 0px;
    width: 240px;
    padding: 10px;
    background-color: #fff;
    border: 1px solid lightgray;
    border-radius: 5px;
`

export const modeSelector = (isSelected) => css`
    box-sizing: border-box;
    width: 120px;
    padding: 20px;
    background-color: #fff;
    border-radius: 5px;
    cursor: pointer;
    border: none;
    color: #000;

    &:hover {
        [class^=fg-] {
            color: #fff;
        }
        span {
            color: #2E76F8;
        }
        div {
            background-color: #2E76F8;
        }
    }

    ${isSelected && css`
        [class^='fg-'] {
            color: #fff;
        }
        span {
            color: #2E76F8;
        }
        div {
            background-color: #2E76F8;
        }
    `}
`

export const modeSelectIconContainer = css`
    box-sizing: border-box;
    width: 48px;
    height: 48px;
    padding: 10px;
    margin: 0px auto 10px auto;
    background-color: #D9D9D9;
    border-radius: 100%;
    font-size: 28px;

    [class^=fg-] {
        display: flex;
    }
`

export const modeSelectText = css`
    font-size: 16px;
    white-space: nowrap;
`